export enum EnumProductTypes {
  Agency = 0,
  OrganisationTravel = 1,
  Individual = 2
}
